import {
    CREATE_YARN_INWARD_FAILURE,
    CREATE_YARN_INWARD_REQUEST,
    CREATE_YARN_INWARD_SUCCESS,
    CREATE_USER_FORM_YARN_INWARD,
    FETCH_SINGLE_YARN_INWARD_FAILURE,
    FETCH_SINGLE_YARN_INWARD_REQUEST,
    FETCH_SINGLE_YARN_INWARD_SUCCESS,
    FETCH_YARN_INWARD_FAILURE,
    FETCH_YARN_INWARD_REQUEST,
    FETCH_YARN_INWARD_SUCCESS,
    NAVIGATE_YARN_INWARD_DETAILS,
    NAVIGATE_YARN_INWARD,
    YARN_INWARD_USERFORM_RESET,
    UPDATE_YARN_INWARD_FAILURE,
    UPDATE_YARN_INWARD_REQUEST,
    UPDATE_YARN_INWARD_SUCCESS,
    DELETE_YARN_INWARD_REQUEST,
    DELETE_YARN_INWARD_SUCCESS,
    DELETE_YARN_INWARD_FAILURE,
    FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE,
    RESET_FORM_DATA_WITHOUT_INWARD_ID,
    SET_ACTIVE_KEY_YARN_INWARD,
    SET_PENDING_GRID_NAME_YARN_INWARD,
    SET_UNIT_NAME_YARN_INWARD,
    SET_END_DATE_YARN_INWARD,
    SET_START_DATE_YARN_INWARD,
    FILE_UPLOAD_YARN_PO_IN_INWARD_SUCCESS,
    FILE_UPLOAD_YARN_PO_IN_INWARD_FAILURE,
    FILE_UPLOAD_YARN_PO_IN_INWARD_REQUEST,
    FILE_UPLOAD_INWARD,
    FILE_UPLOAD_INWARD_RESET
} from './yarnInward.actionsType';

export const YARN_INWARD = 'yarnInward';

let initialState = {
    loading: false,
    yarnInward: [],
    pendingYarnPO: [],
    detailsId: [],
    activeKey: 1,
    yarnInwardId: '',
    yarnInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false
    },
    selectedTeam: {},
    renderGridBtn: 'pendingGrid',
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
    isYarnInward: false,
    yarnInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    fileUpload: '',
    previewImage: ''

};

export let yarnInwardReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_YARN_INWARD_REQUEST:
        case FETCH_PENDING_YARN_PO_IN_INWARD_REQUEST:
        case CREATE_YARN_INWARD_REQUEST:
        case FETCH_SINGLE_YARN_INWARD_REQUEST:
        case UPDATE_YARN_INWARD_REQUEST:
        case DELETE_YARN_INWARD_REQUEST:
        case FILE_UPLOAD_YARN_PO_IN_INWARD_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInward: updatePayload
            };
        case FETCH_PENDING_YARN_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingYarnPO: updatePayload
            };
        case FILE_UPLOAD_INWARD:
            return {
                ...state,
                loading: false,
                fileUpload: payload
            }
        case FILE_UPLOAD_INWARD_RESET:
            return {
                ...state,
                loading: false,
                fileUpload: ''
            }
        case CREATE_YARN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false
                },
                yarnInwardId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_YARN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                yarnInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldInwardDate: payload?.fldInwardDate && payload?.fldInwardDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_YARN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false
                }
            };
        case DELETE_YARN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false
                }
            };
        case FETCH_YARN_INWARD_FAILURE:
        case FETCH_PENDING_YARN_PO_IN_INWARD_FAILURE:
        case FETCH_SINGLE_YARN_INWARD_FAILURE:
        case CREATE_YARN_INWARD_FAILURE:
        case UPDATE_YARN_INWARD_FAILURE:
        case DELETE_YARN_INWARD_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case FILE_UPLOAD_YARN_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                previewImage: updatePayload
            }
        case FILE_UPLOAD_YARN_PO_IN_INWARD_FAILURE:
            return {
                ...state,
                loading: false,
                previewImage: [],
                errorMessage: updatePayload
            }
        case CREATE_USER_FORM_YARN_INWARD:
            return {
                ...state,
                loading: false,
                yarnInwardForm: {
                    ...state.yarnInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_YARN_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_YARN_INWARD:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_YARN_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_YARN_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_YARN_INWARD:
            return {
                ...state,
                endDate: payload
            };
        case YARN_INWARD_USERFORM_RESET:
            return {
                ...state,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false
                },
                yarnInwardId: '',
                activeKey: 1,
                selectedTeam: {}
            };
        case RESET_FORM_DATA_WITHOUT_INWARD_ID:
            return {
                ...state,
                yarnInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false
                },
                selectedTeam: {}
            };
        case NAVIGATE_YARN_INWARD_DETAILS:
            return {
                ...state,
                isYarnInward: true,
                yarnInwardSelectedValue: updatePayload.yarnInwardSelectedValue
            };
        case NAVIGATE_YARN_INWARD:
            return {
                ...state,
                isYarnInward: false
            };
        default:
            return state;
    }
};
